import server from '../request/encryptRequest';

// 查询推荐商机分页列表
export const queryBizOppPageList = (data) => {
  return server.post('/xiaozi-saas/wireless/inquirePrice/bizOppPageList', data);
};

// 导出商机
export const exportBizOpp = (data) => {
  return server.post('/xiaozi-saas/wireless/inquirePrice/exportBizOpp', data, {
    responseType: 'blob',
  });
};

// 查询商机详情
export const queryBizOppDetail = (data) => {
  return server.post('/xiaozi-saas/wireless/inquirePrice/detail', data);
};

// 查询商机动态信息分页列表
export const queryBizOppDynamicInfoPageList = (data) => {
  return server.post('/xiaozi-saas/wireless/inquirePrice/dynamicInformationPageList', data);
};

// 导出询单备件信息
export const exportSparePart = (params) => {
  return server.post('/xiaozi-saas/wireless/inquirePrice/exportSparePart', params, {
    responseType: 'blob',
  });
};
